import {
  EnumOnereWithDettaglioDTOStato,
  OnereWithDettaglioDTO,
  getGetFrontRichiesteIdQueryKey,
  useGetFrontRichiesteIdOneri,
  usePostFrontRichiesteIdPagamenti,
} from '@framework/api-client';
import { getNetworkErrorMessage } from '@framework/auth';
import { t } from '@framework/i18n';
import { message } from 'antd';
import { queryClient } from '../../../core/network/queryClient';

/**
 * Hook per generare automaticamente i pagamenti dopo l'invio della richiesta.
 */
export function useGenerateAfterSendBurdenPayments(
  submissionId: string | null,
) {
  useGetFrontRichiesteIdOneri(submissionId!, {
    query: {
      keepPreviousData: true,
      onSuccess: data => {
        handleCreatePayment(data);
      },
    },
  });

  const { mutate: createPayment } = usePostFrontRichiesteIdPagamenti({
    mutation: {
      onSuccess: () => {
        // NOTE: Should this throw an error?
        if (!submissionId) return;

        const submissionQueryKey =
          getGetFrontRichiesteIdQueryKey(submissionId)[0];
        queryClient.invalidateQueries({
          predicate: ({ queryKey }) =>
            (queryKey[0] as string).includes(submissionQueryKey),
        });
      },
      onError: error => {
        message.error(getNetworkErrorMessage(error, t("burden-selection-table.errore-in-creazione-pagamento", 'Si è verificato un errore durante la creazione del pagamento. Riprovare.'))); // prettier-ignore
      },
    },
  });

  const handleCreatePayment = (burdens: OnereWithDettaglioDTO[]) => {
    if (
      !burdens ||
      burdens.filter(b => b.stato === EnumOnereWithDettaglioDTOStato.DA_PAGARE)
        .length == 0 ||
      !submissionId
    ) {
      return;
    }

    createPayment({
      id: submissionId,
      data: {
        // Estraggo tutti gli oneri e bolli non pagati e senza pacchetto di pagamento
        richiestaOneri:
          burdens
            ?.filter(b => b.stato === EnumOnereWithDettaglioDTOStato.DA_PAGARE)
            .map(({ id }) => ({ id })) ?? [],
      },
    });
  };
}
